import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect, useMemo } from 'react';
import {
  useAgreementTemplatesLightListByKind,
  useGetAgreementTemplate,
} from 'services/templates/agreement-template';
import { AGREEMENT_TYPE } from 'services/templates/agreement-template/types';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { parseAgreementType } from 'utils/components/contract-template/agreement/agreementTemplate.utils';
import { addItem, findLowestAvailableId } from 'utils/dnd/dndUtilities';

const ContractSideMenuAgreementsList = () => {
  const { values, setFieldValue, namePrefix, setErrors } =
    useFormikContractHelpers();

  const agreementKind =
    values.sideMenu?.customTemplate?.agreementKind ?? 'text';

  const agreementLightList =
    useAgreementTemplatesLightListByKind(agreementKind);

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const agreementTemplate = useGetAgreementTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  const headerTitle = useMemo(
    () =>
      agreementKind === 'paragraph'
        ? i18next.t('contract-template.paragraphSection.custom-condition')
        : i18next.t('contract-template.agreement.custom'),
    [agreementKind]
  );

  useEffect(() => {
    if (!selectedId || !agreementTemplate.data || !parentId) {
      return;
    }

    const agreementType = parseAgreementType(agreementTemplate.data.type);

    if (
      agreementKind === 'paragraph' &&
      agreementType !== AGREEMENT_TYPE.text &&
      agreementType !== AGREEMENT_TYPE.paragraph
    ) {
      return;
    }

    if (
      agreementKind === 'text' &&
      agreementType !== AGREEMENT_TYPE.text &&
      agreementType !== AGREEMENT_TYPE.select
    ) {
      return;
    }

    const contractTemplateForm =
      agreementKind === 'paragraph'
        ? middleware.template.agreement.queryToParagraphFormItem(
            agreementTemplate.data,
            findLowestAvailableId(values.items)
          )
        : middleware.template.agreement.queryToFormItem(
            agreementTemplate.data,
            findLowestAvailableId(values.items)
          );

    if (contractTemplateForm) {
      setFieldValue(namePrefix, addItem(values.items, parentId, contractTemplateForm));
      setFieldValue('sideMenu.customTemplate.selectedId', undefined);
      setErrors({});
    }
  }, [selectedId, agreementTemplate.data, agreementKind]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={agreementLightList.data}
      templateType={TEMPLATE_TYPE.agreement}
      headerTitle={headerTitle}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuAgreementsList;
